import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { useParams } from "react-router-dom";
import useService from "../../Hooks/useService";
import OpportunityService from "../../../Services/Opportunity.service";
import ContentLayout from "../../Layout/ContentLayout";
import NumberService from "../../../Services/Shared/Number.service";
import { AlertInfo } from "../../UI/StandardAlerts/StandardAlerts";
import ServiceResult from "../../UI/ServiceResult/ServiceResult";
import AdvisorStudentsContent from "../../Container/Advisor_Students/AdvisorStudentsContent";
import PersonTypeContextProvider from "../../Hooks/usePersonType";
import withModal from "../../HOCs/withModal";
import FAIcon from "../../UI/FAIcon/FAIcon";
const OpportunityDetailContent = ({ opportunityId, onNavbarRight, }) => {
    const [opportunityState, getOpportunity] = useService(OpportunityService.get);
    React.useEffect(() => {
        if (opportunityId) {
            getOpportunity(opportunityId);
        }
    }, [getOpportunity, opportunityId]);
    const opportunityInfo = React.useMemo(() => opportunityState.data
        ? {
            pipelineId: opportunityState.data.stage.pipeline.id,
            opportunityId: opportunityState.data.id,
        }
        : null, [opportunityState.data]);
    return (_jsx(ServiceResult, { state: opportunityState, children: (opportunity) => (_jsx(PersonTypeContextProvider, { internalName: opportunity.stage.pipeline.personType.internalName, children: opportunityInfo && (
            // @ts-expect-error - TS2741 - Property 'refreshStudentList' is missing in type '{ selectedStudentAffiliationId: string; opportunityInfo: { pipelineId: number; opportunityId: number; }; onNavbarRight: ReactNode; }' but required in type 'Props'.
            _jsx(AdvisorStudentsContent, { selectedStudentAffiliationId: opportunity.subject.affiliationId, opportunityInfo: opportunityInfo, onNavbarRight: onNavbarRight })) })) }));
};
export const OpportunityModal = withModal(({ opportunityId, onModalClosed }) => (_jsx(OpportunityDetailContent, { opportunityId: opportunityId, onNavbarRight: _jsx("button", { className: "btn btn-link text-dark", onClick: () => onModalClosed(), title: "Close Modal", children: _jsx(FAIcon, { icon: "times", srText: "Close Modal" }) }) })), {
    defaultModalProps: { unMountContentWhenClosed: true, size: "fullscreen" },
});
const OpportunityDetail = () => {
    // @ts-expect-error - TS2339 - Property 'opportunityId' does not exist on type '{}'.
    const { opportunityId } = useParams();
    return opportunityId != null && NumberService.isValid(opportunityId) ? (_jsx(OpportunityDetailContent, { opportunityId: parseInt(opportunityId, 10) })) : (_jsx(ContentLayout, { paddingTop: true, className: "fullMinHeightMinusPrimaryNav", children: _jsx(AlertInfo, { message: "No opportunity found" }) }));
};
export default OpportunityDetail;
